<template>
    <div class="window bg">
        <div class="container">
            <menu-option v-bind:back="true" v-bind:is-white="true" v-bind:is-help="false"
                         class="container-horizontal_flex-start" v-bind:back-route="'/selection'"></menu-option>
            <transition :css="false" @enter="enterAnimation" @leave="leaveAnimation" appear>
                <div class="img-container" v-if="showEl">
                    <img :src="getCharacter.openMouth" class="img-container_img">
                    <character-talk v-bind:text="text" v-on:action="diabledEle"
                                    v-bind:show-next="true" v-bind:is-blue="false" v-bind:show-name="true"></character-talk>
                </div>
            </transition>
        </div>
    </div>

</template>

<script>
    import MenuOption from '../components/MenuOption';
    import CharacterTalk from '../components/CharacterTalk';
    import {mapGetters} from 'vuex';
    import anime from 'animejs';

    export default {
        name: "Instruction",
        components: {
            MenuOption,
            CharacterTalk
        },
        computed: {
            ...mapGetters(['getCharacter'])
        },
        methods: {
            enterAnimation(el, done) {
                anime({
                    targets: el,
                    opacity: [0, 1],
                    easing: 'easeInQuad'
                })
            },

            leaveAnimation(el, done) {
                const ani = anime({
                    targets: el,
                    opacity: [1, 0],
                    easing: 'easeInQuad'
                })
                ani.finished.then(() => {
                    done;
                    this.$router.push('/menu')
                })
            },
            diabledEle() {
                this.showEl = false;
            }
        },
        data() {
            return {
                text: 'このゲームは<ruby>表示<rt>ひょうじ</rt></ruby>されたテキストを<ruby>読<rt>よ</rt></ruby>む<ruby>練習<rt>れんしゅう</rt></ruby>モードとフリートークの<ruby>実践<rt>じっせん</rt></ruby>モードがあります。\n' +
                    'どちらをやりますか？',
                showEl: true
            }
        }
    }
</script>

<style scoped>

</style>
